/* TIMESTAMP START 2026-10-09T16:48:50-04:00 | REVISION R003900 */
(() => {
  if (window.jpiBookSigningLoaded) return;
  window.jpiBookSigningLoaded = true;
  const root = window.Shopify?.routes?.root || '/';
  let cartBusy = false;
  const lockCheckout = (locked) => {
    document.querySelectorAll('.cart__ctas, .cart__dynamic-checkout-buttons, .additional-checkout-buttons, .drawer__footer').forEach(element => { element.inert = locked; });
  };
  const request = async (path, payload) => {
    const response = await fetch(root + path, {
      method: payload ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(payload ? { body: JSON.stringify(payload) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
    return data;
  };
  const synchronize = async (cart) => {
    for (const child of cart.items.filter(item => item.properties?._jpi_book_signing === '1')) {
      const parent = cart.items.find(item => item.key === child.parent_relationship?.parent_key);
      if (!parent) throw new Error('Please remove the signing service and add your signed book again.');
      if (child.quantity !== parent.quantity) cart = await request('cart/change.js', { id: child.key, quantity: parent.quantity });
    }
    return cart;
  };
  function cartError(message) {
    let error = document.getElementById('jpi-signing-cart-error');
    if (!error) {
      error = document.createElement('p');
      error.id = 'jpi-signing-cart-error';
      error.setAttribute('role', 'alert');
      (document.querySelector('cart-drawer .drawer__footer, .cart__footer, cart-items') || document.body).prepend(error);
    }
    error.textContent = message;
  }
  function checkoutControl(event) {
    const control = event.target.closest?.('[name="checkout"], a[href$="/checkout"]');
    if (!control || !document.querySelector('[data-jpi-signed-book]:not([data-jpi-signed-book=""])')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (cartBusy) return;
    cartBusy = true;
    lockCheckout(true);
    synchronizeCart().then(() => { window.location.href = root + 'checkout'; }).catch(error => {
      cartError(error.message);
      cartBusy = false;
      lockCheckout(false);
    });
  }
  async function synchronizeCart() { return synchronize(await request('cart.js')); }
  document.addEventListener('click', checkoutControl, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkoutControl({ target: event.submitter, preventDefault: () => event.preventDefault(), stopImmediatePropagation: () => event.stopImmediatePropagation() });
  }, true);
  document.addEventListener('change', async event => {
    const input = event.target;
    const row = input.closest?.('[data-jpi-signed-book]:not([data-jpi-signed-book=""])');
    if (!row || !input.matches('input[name="updates[]"]')) return;
    event.stopImmediatePropagation();
    if (cartBusy) { input.value = input.defaultValue; return; }
    const quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0) { input.value = input.defaultValue; return; }
    cartBusy = true;
    lockCheckout(true);
    try {
      const cart = await request('cart/change.js', { id: row.dataset.jpiSignedBook, quantity });
      await synchronize(cart);
      window.location.reload();
    } catch (error) {
      cartError(error.message);
      input.value = input.defaultValue;
      cartBusy = false;
      lockCheckout(false);
    }
  }, true);
  class JpiBookSigning extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      this.choice = this.querySelector('[data-signing-choice]');
      this.personalization = this.querySelector('[data-personalization]');
      this.choice.disabled = false;
      this.choice.addEventListener('change', () => this.update());
      this.personalization.addEventListener('input', () => this.personalization.setCustomValidity(''));
      this.form.addEventListener('submit', event => this.submit(event), true);
      this.update();
      this.alternateObserver = new MutationObserver(() => this.updateAlternatePurchase());
      this.alternateObserver.observe(document.body, { childList: true, subtree: true });
    }
    disconnectedCallback() { this.alternateObserver?.disconnect(); }
    updateAlternatePurchase() {
      const button = document.querySelector('.cbb-frequently-bought-add-button');
      if (!button) return;
      if (!button.dataset.jpiOriginalLabel) button.dataset.jpiOriginalLabel = button.textContent;
      const signed = Boolean(this.choice.value);
      button.disabled = signed;
      const label = signed ? 'Add signed book above' : button.dataset.jpiOriginalLabel;
      if (button.textContent !== label) button.textContent = label;
    }
    update() {
      const selected = this.choice.selectedOptions[0];
      const personalized = selected.dataset.personalized === 'true';
      this.querySelector('[data-personalization-field]').hidden = !personalized;
      this.personalization.disabled = !personalized;
      this.personalization.required = personalized;
      this.personalization.setCustomValidity('');
      this.updateAlternatePurchase();
      const total = (Number(this.dataset.basePrice) + Number(selected.dataset.price || 0)) / 100;
      this.querySelector('[data-signing-total]').textContent = 'Price per copy: ' + new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(total);
    }
    async submit(event) {
      if (!this.choice.value) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      const personalized = this.choice.selectedOptions[0].dataset.personalized === 'true';
      const wording = this.personalization.value.trim();
      this.personalization.setCustomValidity(personalized && !wording ? 'Please enter your personalization.' : '');
      if (!this.personalization.reportValidity()) return;
      const formData = new FormData(this.form);
      const id = Number(formData.get('id'));
      const quantity = Number(formData.get('quantity') || 1);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      const group = window.crypto.randomUUID();
      const properties = { _jpi_signing_group: group };
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      }
      const fee = { _jpi_book_signing: '1', _jpi_signing_group: group, 'Signed by': 'Stewart Lundy' };
      if (personalized) fee.Personalization = wording;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const payload = { items: [
        { id, quantity, properties },
        { id: Number(this.choice.value), quantity, parent_id: id, properties: fee }
      ] };
      if (cart?.getSectionsToRender) {
        payload.sections = cart.getSectionsToRender().map(section => section.id);
        payload.sections_url = window.location.pathname;
      }
      const button = this.form.querySelector('[type="submit"]');
      const productForm = this.closest('product-form');
      this.busy = true;
      button.disabled = true;
      button.classList.add('loading');
      productForm?.handleErrorMessage?.();
      this.form.querySelector('.loading__spinner')?.classList.remove('hidden');
      try {
        const result = await request('cart/add.js', payload);
        try {
          if (!cart?.renderContents) { window.location.href = root + 'cart'; return; }
          cart.classList.remove('is-empty');
          cart.renderContents({ ...result, key: result.items?.[0]?.key });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jpi-book-signing', productVariantId: id, cartData: result });
        } catch (_) { window.location.href = root + 'cart'; }
      } catch (error) {
        if (productForm?.handleErrorMessage) productForm.handleErrorMessage(error.message);
        else cartError(error.message);
      } finally {
        this.busy = false;
        button.disabled = false;
        button.classList.remove('loading');
        this.form.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    }
  }
  customElements.define('jpi-book-signing', JpiBookSigning);
})();
/* TIMESTAMP END 2026-10-09T16:48:50-04:00 | REVISION R003900 */
